import { BULK_UPDATE_EVENTS_PRIVACY } from '@/gql/cronofy';
import { CronofyBulkUpdateEventsPrivacyResponse } from '@/gql/cronofy/types';
import { fetchData } from '@/services/graphql';
import { useMutation } from '@tanstack/react-query';

const useCronofyBulkUpdateEventsPrivacy = () => {
  return useMutation({
    mutationFn: () => fetchData<CronofyBulkUpdateEventsPrivacyResponse>(BULK_UPDATE_EVENTS_PRIVACY, {}),
  });
};

export default useCronofyBulkUpdateEventsPrivacy;
